import { getStage } from "src/context";
import { Css } from "~generated/css";

export function LocalProdWarning() {
  const stage = getStage();

  if (stage !== "local-prod") {
    console.error(
      "The LocalProdWarning component was instantiated outside the local-prod environment. This should not happen! Please debug where this component is rendered.",
    );
    return null;
  }

  return (
    <div css={Css.bgRed100.w100.absolute.top0.z(999).h("48px").df.aic.$} data-testid="localProdWarning">
      <div css={Css.mx3.$}>
        Please sign in at{" "}
        <a href={`https://design.homebound.com/signIn`} data-testid="localProdWarning_link">
          design.homebound.com
        </a>{" "}
        then reload this page to pick up your auth token.
      </div>
    </div>
  );
}
